import { render, staticRenderFns } from "./CampaignFilter.vue?vue&type=template&id=b05a480c"
import script from "./CampaignFilter.vue?vue&type=script&lang=js"
export * from "./CampaignFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports